import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Briefcase, LineChart, Store, Sparkles, Compass } from "lucide-react";
import { AUDIENCE } from "@/constants/content";

const ICONS = [GraduationCap, Briefcase, LineChart, Store, Sparkles, Compass];

const WhoShouldJoin = () => (
  <section id="who" className="section-pad relative">
    <div
      aria-hidden
      className="absolute inset-0 -z-10"
      style={{ background: "linear-gradient(180deg, #f5f7fa, #ffffff)" }}
    />
    <div className="container-x">
      <div className="max-w-3xl">
        <div className="chip">Who Should Join</div>
        <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}>
          Made for beginners. <span className="gradient-text-emerald">Loved by builders</span>.
        </h2>
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {AUDIENCE.map((a, i) => {
          const Icon = ICONS[i] || GraduationCap;
          return (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group rounded-3xl bg-white p-6 border border-slate-100 shadow-premium hover:-translate-y-1 transition-transform"
            >
              <div className="w-11 h-11 rounded-2xl bg-emerald-50 border border-emerald-100 text-emerald-700 grid place-items-center">
                <Icon className="w-5 h-5" />
              </div>
              <div className="mt-4 font-display font-bold text-lg text-slate-900">{a.title}</div>
              <div className="mt-1.5 text-sm text-slate-600">{a.body}</div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhoShouldJoin;
